import ApiService from "../../services/api.service";

function initialState() {
    return {
        klaviyo_events: null
    };
}

const getters = {
    klaviyo_events: state => state.klaviyo_events
};

const actions = {
    setKlaviyoEvents({ commit }, data) {
        commit('setKlaviyoEvents', data);
    },
    storeKlaviyoEvent({commit}, data) {
        return new Promise((resolve, reject) => {
            ApiService.post("klaviyo_events/store", data)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getKlaviyoEvent({commit}, anonymousId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`klaviyo_events/${anonymousId}`)
                .then((response) => {
                    commit('setKlaviyoEvents', response.data)
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    deleteKlaviyoEvent({commit}, anonymousId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`klaviyo_events/${anonymousId}`)
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    resetState({ commit }) {
        commit('resetState');
    }
};

const mutations = {
    setKlaviyoEvents(state, data) {
        state.klaviyo_events = data;
    },
    resetState(state) {
        state = Object.assign(state, initialState());
    }
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
};
